// extracted by mini-css-extract-plugin
module.exports = {"cropText":"styles_cropText__2r0sK"};